import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { PDP_CALL_SOURCE } from '@shared/models/shared.model';
import { CmsService, Page, UrlPipe, TranslatePipe } from '@spartacus/core';
import { ProductListItemComponent, ProductListItemContext, ProductListItemContextSource, MediaComponent, OutletDirective } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import {ProductListOptionsService} from "../../services/product-list-options.service";
import { RouterLink } from '@angular/router';
import { ProductBadgeComponent } from '../../../shared/components/badge/product-badge.component';
import { EfaAddToCartComponent } from '../../../add-to-cart/components/efa-add-to-cart/efa-add-to-cart.component';
import { EfaCartItemAddToWishListComponent } from '../../../shared/components/efa-cart-item-add-to-wish-list/efa-cart-item-add-to-wish-list.component';

@Component({
    selector: 'app-efa-product-list-item',
    templateUrl: './efa-product-list-item.component.html',
    providers: [
        ProductListItemContextSource,
        {
            provide: ProductListItemContext,
            useExisting: ProductListItemContextSource
        },
    ],
    imports: [RouterLink, MediaComponent, ProductBadgeComponent, OutletDirective, EfaAddToCartComponent, EfaCartItemAddToWishListComponent, UrlPipe, TranslatePipe]
})
export class EfaProductListItemComponent extends ProductListItemComponent implements OnInit, OnDestroy {
  pdpCallSource: PDP_CALL_SOURCE;

  private subscription: Subscription = new Subscription();

  constructor(
    protected productListItemContextSource: ProductListItemContextSource,
    protected cmsService: CmsService,
    protected optionsService: ProductListOptionsService
  ) {
    super(productListItemContextSource);
  }

  ngOnInit(): void {
    this.subscription.add(this.cmsService.getCurrentPage().subscribe((page: Page) => {
      if (page?.pageId === 'search') {
        this.pdpCallSource = PDP_CALL_SOURCE.SEARCH;
      } else {
        this.pdpCallSource = PDP_CALL_SOURCE.CATEGORY;
      }
    }));
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
}
